export default "__VITE_ASSET__cd18a725__"